"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawLineBresenham = void 0;
// http://www.roguebasin.com/index.php/Bresenham%27s_Line_Algorithm#JavaScript
// Bresenham's Line Algorithm
var drawLineBresenham = function (x0, y0, x1, y1, plot) {
    var tmp = 0;
    var steep = Math.abs(y1 - y0) > Math.abs(x1 - x0);
    if (steep) {
        //swap x0,y0
        tmp = x0;
        x0 = y0;
        y0 = tmp;
        //swap x1,y1
        tmp = x1;
        x1 = y1;
        y1 = tmp;
    }
    var sign = 1;
    if (x0 > x1) {
        sign = -1;
        x0 *= -1;
        x1 *= -1;
    }
    var dx = x1 - x0;
    var dy = Math.abs(y1 - y0);
    var err = dx / 2;
    var ystep = y0 < y1 ? 1 : -1;
    var y = y0;
    var count = 0;
    var count2 = 0;
    for (var x = x0; x <= x1; x++) {
        if (!(steep
            ? plot(y, sign * x, count, count2)
            : plot(sign * x, y, count, count2)))
            return;
        count++;
        count2++;
        err = err - dy;
        if (err < 0) {
            y += ystep;
            err += dx;
            count2 += 0.42; // Roughly 1 - sqrt(2)
        }
    }
};
exports.drawLineBresenham = drawLineBresenham;
